<template>
  <div class="my_wallet">
    <div class="top-wallet">
      <div class="yu-title">账户余额</div>
      <div class="price_info">
        <div class="price-left">
          <span class="dianqian">{{ balance.toString().split(".")[0] }}.</span>
          <span class="dianhou">
            {{
              balance.toString().split(".")[1] == null
                ? "00"
                : balance.toString().split(".")[1]
            }}
          </span>
          <span class="company">元</span>
          <el-button class="recharge pricebtn" @click="openRecharge()"
            >充值</el-button
          >
          <el-button class="tixian pricebtn" @click="withdrawTipsVisible = true"
            >提现</el-button
          >
        </div>
        <div class="price-right">
          <!-- <div class="dongjie"><span class="tab">冻结资金:</span>¥365.36</div> -->
          <div class="tixianzhong">
            <span class="tab">提现中:</span>
            ¥{{ withdrawing }}
            <span class="mingxi" @click="openWithdraw()">
              提现明细
              <svg class="icon iconhome_title_more" aria-hidden="true">
                <use xlink:href="#iconhome_title_more" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-wallet">
      <div class="price-tab">
        <div
          class="price-tab-item"
          v-for="(item, index) in priceTab"
          :class="{ selected: item.isSelected }"
          @click="priceListCheck(item)"
        >
          {{ item.name }}
        </div>
        <div class="daochu" @click="exportExcel()">
          <svg class="icon iconbiaodan_vedioup" aria-hidden="true">
            <use xlink:href="#iconbiaodan_vedioup" />
          </svg>
          导出
        </div>
      </div>
      <div id="range_date" class="range-date">
        下单时间
        <el-date-picker
          class="screen range_date"
          v-model="timeSlot"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          @change="getcashFlowList"
        ></el-date-picker>
        <el-button class="order_search" @click="orderClear()">重置</el-button>
      </div>
    </div>

    <div class="price-form">
      <div class="price-form-title">
        <div class="transaction-time">交易时间</div>
        <div class="transaction-type">交易类型</div>
        <div class="transaction-type">交易方式</div>
        <div class="transaction-price">交易金额</div>
        <div class="transaction-content">内容</div>
        <div class="transaction-state">状态</div>
        <div class="transaction-yue">交易后余额</div>
      </div>
      <div class="price-form-list">
        <div class="price-item" v-for="(item, index) in cashFlowList.rows">
          <div class="transaction-time">{{ item.createTime }}</div>
          <div class="transaction-type">{{ getCashFlowType(item) }}</div>
          <div class="transaction-type">{{ getPayWay(item) }}</div>
          <div
            class="transaction-price"
            :class="item.previousAmount > item.nextAmount ? 'red' : 'green'"
          >
            {{
              item.previousAmount > item.nextAmount
                ? "-¥" + item.amount
                : "+¥" + item.amount
            }}
            <!-- {{
              item.type == "REFUND" || item.type == "RECHARGE" ? "+" : "-"
            }}¥{{ item.amount }} -->
          </div>
          <div class="transaction-content">
            {{ item.content.split("|")[0] }}
          </div>
          <div class="transaction-state">交易成功</div>
          <div class="transaction-yue">¥{{ item.nextAmount }}</div>
        </div>
        <div class="null" v-show="cashFlowList.total == 0 && loading">
          <img src="../../assets/img/pic_none.png" alt />
          <div>没有搜索到相关数据…</div>
        </div>
      </div>
      <div class="price-fenye">
        <el-pagination
          v-if="cashFlowList.total > 12"
          background
          layout="prev, pager, next"
          :total="cashFlowList.total"
          :page-size="12"
          @current-change="pageSize"
        ></el-pagination>
      </div>
    </div>
    <!-- 交易表格导出 -->
    <el-table
      id="outTable"
      :data="cashFlowLists.rows"
      style="width: 100%;display:none;"
      v-show="false"
    >
      <el-table-column prop="createTime" label="交易时间"></el-table-column>
      <el-table-column label="交易类型">
        <template slot-scope="{ row }">
          <span>{{ getCashFlowType(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易方式">
        <template slot-scope="{ row }">
          <span>{{ getPayWay(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易金额">
        <template slot-scope="{ row }">
          <span>{{ row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="内容">
        <template slot-scope="{ row }">
          <span>{{ row.content.split("|")[0] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template>
          <span>交易成功</span>
        </template>
      </el-table-column>
      <el-table-column label="交易后余额">
        <template slot-scope="{ row }">
          <span>{{ row.nextAmount }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="提现提示"
      :visible.sync="withdrawTipsVisible"
      @close="withdrawTipsVisible = false"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add">
        <el-row :gutter="20">
          <el-col><div>1、直接联系平台：028-64967606 (周一至周五 09:00-18:00)</div></el-col>
          <el-col><div>2、发送提现邮件到：xulei@51jushifu.com，我们收到邮件会有专人联系您
            <div style="margin-top: 20px;">标题: 聚师傅系统提现申请</div>
            <div>内容: 手机号 (您的登录手机账户) ，提现金额。联系人姓名和联系电话</div>
            
            </div></el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-show="false" @click="withdrawTipsVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="withdrawTipsVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      timeSlot: ["", ""],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      priceTab: [
        { name: "全部", isSelected: true, type: "" },
        { name: "充值", isSelected: false, type: "RECHARGE" },
        { name: "消费", isSelected: false, type: "PLACE_AN_ORDER" },
        { name: "提现", isSelected: false, type: "CASH_OUT" },
        { name: "提现拒绝", isSelected: false, type: "CASH_OUT_REJECT" },
        { name: "退款", isSelected: false, type: "REFUND" },
        { name: "奖励", isSelected: false, type: "REWARD" },
        { name: "处罚", isSelected: false, type: "FINE" },
        { name: "加价", isSelected: false, type: "MARKUP" },
      ],
      priceList: [
        {
          time: "2018-01-09  15:02",
          type: "消费",
          mode: "微信余额",
          price: "-¥100.00",
          content: "订单 6226056967666599",
          state: "交易成功",
          yue: "¥3653.25",
        },
      ],
      loading: false,
      page: 1,
      balance: "",
      withdrawing: "",
      cashFlowList: {
        rows: [],
        total: 0,
      },
      cashFlowLists: {
        rows: [],
      },
      cashFlowtype: "",
      withdrawTipsVisible: false,
    };
  },
  activated() {},
  mounted() {
    var _this = this;
    if (Cookies.get("token") != undefined) {
      this.$fetch(`/user/api/customer/balance`).then((res) => {
        if (res.code == 0) {
          _this.withdrawing = res.data.withdrawing;
          _this.balance = res.data.balance;
        } else {
          this.$message(res.message);
        }
      });
      this.getcashFlowList();
    }
  },
  computed: {
    getCashFlowType() {
      let result = "";
      return function(item) {
        if (item.type == "PLACE_AN_ORDER") {
          result = "消费";
        }
        if (item.type == "REFUND") {
          result = "退款";
        }
        if (item.type == "MARKUP" || item.type == "MARKUP_REQUEST") {
          result = "加价";
        }
        if (item.type == "VALUE_ADDED") {
          result = "增值服务";
        }
        if (item.type == "BONUS") {
          result = "分红";
        }
        if (item.type == "REBATE") {
          result = "返利";
        }
        if (item.type == "ORDER_PROFIT") {
          result = "订单收益";
        }
        if (item.type == "RECHARGE") {
          result = "充值";
        }
        if (item.type == "CASH_OUT") {
          result = "提现";
        }
        if (item.type == "CASH_OUT_REJECT") {
          result = "提现拒绝";
        }
        if (item.type == "FINE") {
          result = "用户处罚";
        }
        if (item.type == "REWARD") {
          result = "用户奖励";
        }
        return result;
      };
    },
    getPayWay() {
      let result = "";
      return function(item) {
        if (item.payWay == "ALIPAY") {
          result = "支付宝";
        }
        if (item.payWay == "WECHAT") {
          result = "微信";
        }
        if (item.payWay == "WALLET") {
          result = "钱包";
        }
        return result;
      };
    },
  },
  methods: {
    // 导出excel
    exportExcel() {
      this.getExportList().then((res) => {
        var wb = XLSX.utils.table_to_book(document.querySelector("#outTable"));
        /* get binary string as output */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "钱包明细.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      });
    },
    // 获取导出列表
    async getExportList() {
      let _this = this;
      let response;
      let startTime = _this.timeSlot[0];
      let endTime = _this.timeSlot[1];
      await this.$post(
        `/order/api/cash_flow/list?pageIndex=${this.page}&pageSize=99999&type=${this.cashFlowtype}&startTime=${startTime}&endTime=${endTime}&cashType=4`
      ).then((res) => {
        if (res.code == 0) {
          // console.log(res);
          _this.cashFlowLists = res.data;
          response = res;
        } else {
          this.$message(res.message);
        }
      });
      return response;
    },
    // 重置表单
    orderClear() {
      this.timeSlot = ["", ""];
      this.priceTab.map((i) => {
        i.isSelected = false;
        if (!i.type) {
          i.isSelected = true;
        }
      });
      this.page = 1;
      this.cashFlowtype = "";
      this.getcashFlowList();
    },
    // 获取流水列表
    getcashFlowList() {
      var _this = this;
      let startTime = _this.timeSlot[0];
      let endTime = _this.timeSlot[1];
      this.$post(
        `/order/api/cash_flow/list?pageIndex=${this.page}&pageSize=12&type=${this.cashFlowtype}&startTime=${startTime}&endTime=${endTime}&cashType=4`
      ).then((res) => {
        if (res.code == 0) {
          _this.cashFlowList = res.data;
          this.loading = true;
        } else {
          this.$message(res.message);
        }
      });
    },
    priceListCheck(item) {
      for (let i of this.priceTab) {
        i.isSelected = false;
      }
      this.cashFlowtype = item.type;
      item.isSelected = true;
      this.getcashFlowList();
    },
    // 页数
    pageSize(val) {
      this.page = val;
      this.getcashFlowList();
    },
    // 进入提现明细
    openWithdraw() {
      this.$router.push({ path: "/user/wallet/withdraw" });
    },
    // 余额充值
    openRecharge() {
      this.$router.push({ path: "/user/wallet/recharge" });
    },
    // 提现申请
    applyWithdraw() {
      this.$router.push({ path: "/user/wallet/money" });
    },
  },
};
</script>
<style lang="scss">
#range_date .range_date input.el-range-input::placeholder {
  font-size: 12px;
}
#range_date .range_date input.el-range-input {
  font-size: 12px;
}
.el-pager li,
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  // width: 32px !important;
  width: auto !important;
  height: 32px !important;
  line-height: 32px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  border-color: #3455d3 !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  margin: 0 4px !important;
}
.default-input {
  input {
    width: 190px;
    height: 30px;
    border-radius: 2px;
    border: 1px solid rgba(220, 223, 230, 1);
    padding: 9px 15px;
    font-size: 12px;
  }
  input:hover,
  input:focus,
  textarea:hover,
  textarea:focus {
    border-color: #3455d3 !important;
  }
  input::placeholder {
    font-size: 12px;
  }
}
</style>
<style lang="scss">
.my_wallet {
  #range_date .range_date {
    width: 210px;
    height: 30px;
    margin-left: 8px;
    margin-top: 10px;
  }
  .top-wallet {
    height: 154px;
    background: #ffffff;
    padding: 24px 20px 46px 20px;
    border-bottom: 1px solid #e8eef5;
    .yu-title {
      height: 18px;
      font-size: 18px;
      color: rgba(94, 96, 102, 1);
      line-height: 18px;
      margin-bottom: 23px;
    }
    .price_info {
      display: flex;

      .price-left {
        position: relative;
        color: #f75658;
        height: 40px;
        line-height: 1;
        display: flex;
        align-items: flex-end;
        .dianqian {
          font-size: 40px;
        }
        .dianhou {
          font-size: 20px;
        }
        .company {
          color: #909399;
          font-size: 20px;
          margin-left: 10px;
          margin-right: 16px;
        }
        .pricebtn {
          width: 52px;
          height: 24px;
          border-radius: 2px;
          padding: 0;
          font-size: 12px;
          cursor: pointer;
        }
        .recharge {
          background: rgba(52, 85, 211, 1);
          border: 1px solid rgba(52, 85, 211, 1);
          color: #ffffff;
        }
        .tixian {
          border: 1px solid rgba(190, 192, 198, 1);
          color: #5e6066;
        }
      }
      .price-left::after {
        content: "";
        height: 48px;
        width: 1px;
        position: absolute;
        background: #e8eef5;
        // left: 324px;
        right: -60px;
        top: -3px;
      }
      .price-right {
        margin-left: 119px;
        // margin-top: 4px;
        display: flex;
        align-items: center;
        .dongjie {
          margin-top: -15px;
        }
        .tixianzhong {
          // margin-top: 15px;
        }
        .dongjie,
        .tixianzhong {
          color: #5e6066;
          font-size: 20px;
          height: 20px;
          line-height: 1;
          .tab {
            width: 51px;
            font-size: 12px;
            margin-right: 16px;
            height: 12px;
            line-height: 1;
            display: inline-block;
          }
          .mingxi {
            color: #3455d3;
            font-size: 12px;
            display: inline-flex;
            cursor: pointer;
            .iconhome_title_more {
              color: #3455d3;
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
  }
  .bottom-wallet {
    height: 96px;
    background: #ffffff;
    .price-tab {
      height: 46px;
      padding: 14px 20px;
      color: #2f3133;
      font-size: 14px;
      display: flex;
      position: relative;
      .price-tab-item {
        margin-right: 36px;
        cursor: pointer;
        &:hover {
          color: #3455d3;
        }
      }
      .price-tab-item:last-child {
        margin-right: 0;
      }
      .selected {
        font-weight: bold;
        color: #3455d3;
        border-bottom: 1px solid #3455d3;
        padding-bottom: 25px;
      }
      .daochu {
        position: absolute;
        color: #b4b7bc;
        font-size: 12px;
        top: 13px;
        right: 20px;
        cursor: pointer;
        .iconbiaodan_vedioup {
          width: 14px;
          height: 13px;
          color: #b4b7bc;
          margin-right: 2px;
        }
        &:hover {
          color: #2f3133;
          .iconbiaodan_vedioup {
            color: #2f3133;
          }
        }
      }
    }
    .range-date {
      font-size: 12px;
      color: #5e6066;
      padding-left: 20px;
    }
  }
  .price-form {
    margin-top: 15px;
    background: #ffffff;
    margin-bottom: 100px;
    padding-bottom: 20px;
    .price-form-title {
      background: #f9fafa;
      display: flex;
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #5e6066;
        font-size: 12px;
        height: 36px;
      }
    }
  }
  .transaction-time {
    width: 129px;
  }
  .transaction-type {
    width: 94px;
  }
  .transaction-price {
    width: 120px;
  }
  .green {
    color: #46ae32;
  }
  .red {
    color: #f75658;
  }
  .transaction-content {
    width: 273px;
    // padding-right: 88px;
  }
  .transaction-state {
    width: 70px;
  }
  .transaction-yue {
    width: 117px;
  }
  .price-item {
    display: flex;
    .transaction-content {
      width: 273px;
      padding-right: 0;
    }
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      font-size: 12px;
    }
  }
  .price-item:nth-child(2n) {
    background: #f9fafa;
  }
  .price-fenye {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
<style lang="scss" scoped>
.order_search {
  width: 124px;
  height: 30px;
  background: #3455d3;
  border-color: #3455d3;
  border-radius: 2px;
  font-size: 14px;
  line-height: 5px;
  color: #fff;
  margin-left: 10px;
  &:hover,
  &:active {
    background: #2c4abb;
    border-color: #2c4abb;
    color: #fff;
  }
}

#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }
}
</style>
